module.exports = __webpack_public_path__ + "static/media/lang.3778680c.svg";